import { useState, useEffect, useCallback, useMemo } from "react";
import Container from "react-bootstrap/Container";
import FileCard from "./FileCard";
import GalleryFileCard from "./GalleryFileCard";
import Loading from "../common/Loading";
import { apiRequest } from "../utils/authConfig";
import { useMsal, account } from "../utils/authContext";
import Uploader from "../common/Uploader";
import AlertDismissible from "../common/AlertDismissible";
import { Col, Row } from "react-bootstrap";
import { getFiles } from "./FileService";

const Files = (props: any) => {
  const { getToken } = useMsal();
  const galleryMode = props?.galleryMode;
  const handleSelected = props?.handleSelected;
  const galleryItems = props.galleryItems;
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const args = useMemo(() => ({ ...apiRequest, account }), []);
  const handleDelete = async () => {
    try {
      await loadContent();
    } catch (err: any) {
      handleError(err);
    }
  };
  const handleError = (err: Error) => {
    setError(err.message);
  };
  const loadContent = useCallback(async () => {
    setIsLoading(true);
    setError("");
    try {
      const json = await getFiles(getToken, args);
      setItems(json.data);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoaded(true);
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [args]);

  useEffect(() => {
    if (!loaded && !isLoading) {
      loadContent();
    }
  }, [loaded, isLoading, loadContent]);
  return (
    <>
      {error && (
        <AlertDismissible variant="danger" className="mt-4">
          {error}
        </AlertDismissible>
      )}
      <Container>
        <Row>
          <Col md="6" lg="4">
            <Uploader
              endpoint="/file"
              onUploadComplete={loadContent}
              onError={setError}
            />
          </Col>
        </Row>
        {!isLoading &&
          galleryMode &&
          items.map((file) => (
            <GalleryFileCard
              url={file}
              key={file}
              galleryItems={galleryItems}
              handleSelected={handleSelected}
              onDelete={handleDelete}
              onError={handleError}
            />
          ))}
        {!isLoading &&
          !galleryMode &&
          items.map((file) => (
            <FileCard
              url={file}
              key={file}
              onDelete={handleDelete}
              onError={handleError}
            />
          ))}
        {isLoading && <Loading />}
        {!isLoading && !items.length && <span>No records</span>}
      </Container>
    </>
  );
};

export default Files;
